// Project
export const READ = 'READ'
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'
export const OPEN_NOTIF = 'OPEN_NOTIF'
export const CLOSE_NOTIF = 'CLOSE_NOTIF'



// WEBPACK FOOTER //
// ./src/common/store/Notifications/types.js